
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/index/[shopSysNo]",
      function () {
        return require("private-next-pages/shop/index/[shopSysNo].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/index/[shopSysNo]"])
      });
    }
  